import React from "react"
import styles from "../../../common/GoogleOriginalDesign/Foodslabo/LpcatsDesign/RegisterCommon.module.css"
import RegisterCommon from "../../../common/GoogleOriginalDesign/Foodslabo/LpcatsDesign/RegisterCommon"

const sectionsData = [
    {
        id: "sec1",
        title: "【Google関西限定】飲食業界で働く方が支持する転職サービス",
        img: "/lp/google/foodslabo/kansai/1.jpg",
        label: "CT_Sec1",
    },
    {
        id: "sec2",
        title: "限定求人1",
        img: "/lp/google/foodslabo/kansai/2.jpg",
        label: "CT_Sec2",
    },
    {
        id: "sec3",
        title: "限定求人2",
        img: "/lp/google/foodslabo/kansai/3.jpg",
        label: "CT_Sec3",
    },
    {
        id: "sec4",
        title: "限定求人3",
        img: "/lp/google/foodslabo/kansai/4.jpg",
        label: "CT_Sec4",
    },
    {
        id: "sec5",
        title: "飲食店がみつかる",
        img: "/lp/google/foodslabo/common/5.jpg",
        label: "CT_Sec5",
    },
    {
        id: "sec6",
        title: "完全無料のエージェントサポート",
        img: "/lp/google/foodslabo/common/6.jpg",
        label: "CT_Sec6",
    },
    {
        id: "sec7",
        title: "転職登録者実績",
        img: "/lp/google/foodslabo/common/7.jpg",
        label: "CT_Sec7",
    },
    {
        id: "sec8",
        title: "登録するだけでスカウトが届く",
        img: "/lp/google/foodslabo/common/8.jpg",
        label: "CT_Sec8",
    },
    {
        id: "sec9",
        title: "気になっていた飲食店からあいたいが届く",
        img: "/lp/google/foodslabo/common/9.jpg",
        label: "CT_Sec9",
    },
    {
        id: "sec10",
        title: "簡単web職歴だけで応募できる",
        img: "/lp/google/foodslabo/common/10.jpg",
        label: "CT_Sec10",
    },
    {
        id: "sec11",
        title: "登録後どうするの",
        img: "/lp/google/foodslabo/common/11.jpg",
        label: "CT_Sec11",
    },
    {
        id: "sec12",
        title: "よくある質問",
        img: "/lp/google/foodslabo/common/12.jpg",
        label: "CT_Sec12",
    },
    {
        id: "sec13",
        title: "面談オフィス",
        img: "/lp/google/foodslabo/common/13.jpg",
        label: "CT_Sec13",
    },
]

const fixedBannerData = {
    img: "/lp/common/lpcats_design/banner.jpg",
    alt: "【Google関西限定】無料登録して求人を見る",
    label: "CT_FixedBanner",
}

const bannerLink = "/signup?channel=google_adwords"

export default function GoogleRegisterKansai() {
    return (
        <RegisterCommon
            sectionsData={sectionsData}
            fixedBannerData={fixedBannerData}
            bannerLink={bannerLink}
            styles={styles}
        />
    )
}
